// The admin panel is gated on is_admin, except on the local dev server
// (`vite`), where any logged-in account can use it (Kelvin, 2026-09-30).
// Staging and production builds always check; so does the API, keyed on
// the backend's ENV_TYPE (hasAdminAccess in backend/src/utils/auth.ts).
export const canAccessAdmin = (
  user: { is_admin: boolean } | null | undefined
): boolean => !!user && (user.is_admin || import.meta.env.DEV);
